import React, { FC } from "react"
import { GroupDocument } from "../../../../contexts/devices-context"
import LightModuleSettings from "./LightModuleSettings"
import useModuleAttributes from "../../hooks/useModuleAttributes"

type GroupLightModuleSettingsProps = {
    group: GroupDocument
}

const _GroupLightModuleSettings: FC<GroupLightModuleSettingsProps> = ({ group }) => {
    const attrs = useModuleAttributes<"brightness">(group, "lights")

    return <LightModuleSettings attrs={attrs} organisation={group.organisation} group={group.id} />
}

export default _GroupLightModuleSettings
